export default {
  changeLanguageTips: '언어 전환 성공',
  unknownError: '알 수 없는 오류가 발생했습니다. 관리자에게 문의하십시오!'
}
